import * as Api from '../../../../api/Api';
import { useState } from 'react';
import { useGetToken } from '../../../../Hooks/CustomHooks';
import * as Utilities from '../../../../Components/Utils/Utils';
import { Modal } from 'react-bootstrap-v5';
import makeAnimated from 'react-select/animated';
import Select from 'react-select';
import AgTable from '../../../../Components/Table/AgTable';

function IndicadorVentaRubros({ tipoReporte }) {
    const monthNames = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
        "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
    ];
    const currentDate = new Date();
    const yearold = Utilities.getAnioComparativo()
    const year = currentDate.getFullYear();
    const month = monthNames[currentDate.getMonth()];
    const closedMonth = monthNames[currentDate.getMonth() - 1];

    const day = currentDate.getDate();

    const animatedComponents = makeAnimated();

    const [unidadEconomica, setUnidadEconomica] = useState({
        "value": "3",
        "label": "Santa Anita"
    });
    let unidadesEconomicasList = {
        "defaultId": "3",
        "list": [{
            "value": "3",
            "label": "Santa Anita"
        },
        {
            "value": "2",
            "label": "Arequipa"
        },
        {
            "value": "6",
            "label": "Chiclayo"
        },
        {
            "value": "7",
            "label": "Iquitos"
        },
        {
            "value": "8",
            "label": "San Juan de Lurigancho"
        }
    ]
    };
    const getOptionValueUnidadEconomica = idDefault => {
        return unidadesEconomicasList.list.filter(obj => obj.value === idDefault)
    }
    const onChangeUnidadEconomica = (inputValue) => {
        setUnidadEconomica(inputValue);
    }

    const headerVentaxRubros = [
        {
            headerName: 'CeBe',
            field: 'rubro',
        },
        {
            headerName: `Venta ${(tipoReporte.value === "ventaMensualCerrado") ? closedMonth : month} ${year}`,
            field: 'ventaMesAnioActual',
            type: 'rightAligned',
            cellRenderer: (props) => (
                <>{Utilities.comillasFix(props.data.ventaMesAnioActual, true)}</>
            )
        },
        {
            headerName: `Venta ${(tipoReporte.value === "ventaMensualCerrado") ? closedMonth : month} ${yearold}`,
            field: 'ventaMesAnioPasado',
            type: 'rightAligned',
            cellRenderer: (props) => (
                <>{Utilities.comillasFix(props.data.ventaMesAnioPasado, true)}</>
            )
        },
        {
            headerName: 'Diferencia',
            field: 'diferenciaMonto',
            type: 'rightAligned',
            cellRenderer: (props) => (
                <>{Utilities.comillasFix(props.data.diferenciaMonto, true)}</>
            )
        },
        {
            headerName: '%',
            field: 'diferenciaPorcentaje',
            type: 'rightAligned',
            cellRenderer: (props) => (
                <>{Utilities.setClassDiferenceTable(props.data.diferenciaPorcentaje)}</>
            )
        },
        {
            headerName: 'Contratos',
            cellStyle: { textAlign: 'center' },
            cellRenderer: (props) => (
                <button className="btn btn-light btn-active-light-primary btn-sm" onClick={
                    function () {
                        setCurrentRubroContrato(props.data.rubro);
                        setCurrentRubroId(props.data.rubroId)
                        setShowModal(true);
                    }
                } >
                    <i className="fi-rr-interactive"></i>
                </button >
            )
        }
    ]

    const [showModal, setShowModal] = useState(false);
    const [currentRubroContrato, setCurrentRubroContrato] = useState(null);
    const [currentRubroId, setCurrentRubroId] = useState(null);
    const handleCloseModal = () => setShowModal(false);
    const handleShowModal = () => setShowModal(true);

    const headerListaContratosMes = [
        {
            headerName: 'Contrato',
            field: 'contrato',
            type: 'rightAligned',
        },
        {
            headerName: 'Denominación',
            field: 'denominacion',
        },
        {
            headerComponent: () => (<span>Venta {month}/m<sup>2</sup> {year}</span>),
            field: 'ventaMesAnioActual',
            type: 'rightAligned',
            cellRenderer: (props) => (
                <>{Utilities.comillasFix(props.data.ventaMesAnioActual, true)}</>
            )
        },
        {
            headerComponent: () => (<span>Venta {month}/m<sup>2</sup> {yearold}</span>),
            field: 'ventaMesAnioPasado',
            type: 'rightAligned',
            cellRenderer: (props) => (
                <>{Utilities.comillasFix(props.data.ventaMesAnioPasado, true)}</>
            )
        },
        {
            headerName: 'Dif (S/)',
            field: 'diferenciaMonto',
            type: 'rightAligned',
            cellRenderer: (props) => (
                <>{Utilities.comillasFix(props.data.diferenciaMonto, true)}</>
            )
        },
        {
            headerName: 'Dif (%)',
            field: 'diferenciaPorcentaje',
            type: 'rightAligned',
            cellRenderer: (props) => (
                <>{Utilities.setClassDiferenceTable(props.data.diferenciaPorcentaje)}</>
            )
        }
    ]
    const headerListaContratosMesM2 = [
        {
            headerName: 'Contrato',
            field: 'contrato',
            type: 'rightAligned',
        },
        {
            headerName: 'Denominación',
            field: 'denominacion',
        },
        {
            headerComponent: () => (<span>Area m<sup>2</sup></span>),
            field: 'areaLocal',
            type: 'rightAligned',
            cellRenderer: (props) => (
                <>{Utilities.comillasFix(props.data.areaLocal, true)}</>
            )
        },
        {
            headerComponent: () => (<span>Venta {month}/m<sup>2</sup> {year}</span>),
            field: 'ventaM2MesAnioActual',
            type: 'rightAligned',
            cellRenderer: (props) => (
                <>{Utilities.comillasFix(props.data.ventaM2MesAnioActual, true)}</>
            )
        },
        {
            headerComponent: () => (<span>Venta {month}/m<sup>2</sup> {yearold}</span>),
            field: 'ventaM2MesAnioPasado',
            type: 'rightAligned',
            cellRenderer: (props) => (
                <>{Utilities.comillasFix(props.data.ventaM2MesAnioPasado, true)}</>
            )
        },
        {
            headerName: 'Dif (S/)',
            field: 'diferenciaMonto',
            type: 'rightAligned',
            cellRenderer: (props) => (
                <>{Utilities.comillasFix(props.data.diferenciaMonto, true)}</>
            )
        },
        {
            headerName: 'Dif (%)',
            field: 'diferenciaPorcentaje',
            type: 'rightAligned',
            cellRenderer: (props) => (
                <>{Utilities.setClassDiferenceTable(props.data.diferenciaPorcentaje)}</>
            )
        }
    ]

    const headerListaContratosMesCerrado = [
        {
            headerName: 'Contrato',
            field: 'contrato',
            type: 'rightAligned',
        },
        {
            headerName: 'Denominación',
            field: 'denominacion',
        },
        {
            headerName: `Venta ${closedMonth} cerrado ${year}`,
            field: 'ventaMesCerradoAnioActual',
            type: 'rightAligned',
            cellRenderer: (props) => (
                <>{Utilities.comillasFix(props.data.ventaMesCerradoAnioActual, true)}</>
            )
        },
        {
            headerName: `Venta ${closedMonth} cerrado ${yearold}`,
            field: 'ventaMesCerradoAnioPasado',
            type: 'rightAligned',
            cellRenderer: (props) => (
                <>{Utilities.comillasFix(props.data.ventaMesCerradoAnioPasado, true)}</>
            )
        },
        {
            headerName: 'Dif (S/)',
            field: 'diferenciaMonto',
            type: 'rightAligned',
            cellRenderer: (props) => (
                <>{Utilities.comillasFix(props.data.diferenciaMonto, true)}</>
            )
        },
        {
            headerName: 'Dif (%)',
            field: 'diferenciaPorcentaje',
            type: 'rightAligned',
            cellRenderer: (props) => (
                <>{Utilities.setClassDiferenceTable(props.data.diferenciaPorcentaje)}</>
            )
        }
    ]

    const token = useGetToken();

    return (
        <>
            <div className="card my-5">
                <div className="card-header border-0 pt-5 pb-8">

                    <h3 className="card-title align-items-start flex-column">
                        {tipoReporte.value === "ventaMensual" && <span className="card-label fw-bolder text-gray-800">Venta por Rubros</span>}
                        {tipoReporte.value === "ventaMensualM2" && <span className="card-label fw-bolder text-gray-800">Venta por m<sup>2</sup> por Rubros</span>}
                        {tipoReporte.value === "ventaMensualCerrado" && <span className="card-label fw-bolder text-gray-800">Venta cerrada por Rubros</span>}

                    </h3>

                    <div className="card-toolbar" style={{ minWidth: "200px" }}>

                        <Select
                            classNamePrefix='filter'
                            components={animatedComponents}
                            defaultValue={getOptionValueUnidadEconomica(unidadesEconomicasList.defaultId)}
                            isMulti={false}
                            closeMenuOnSelect={true}
                            options={unidadesEconomicasList.list}
                            onChange={(onChangeUnidadEconomica)}
                        />	</div>

                </div>

                {
                    tipoReporte.value === "ventaMensual" &&
                    (
                        <>
                            <div className="card-body tab-content pt-0">
                                <AgTable
                                    idContent={"IndicadoresVentasMensualXRubros " + tipoReporte.value + unidadEconomica.value}
                                    apiService={Api.IndicadoresVentasMesRubros}
                                    setAuxData={null}
                                    header={headerVentaxRubros}
                                    titleExcel={"Indicadores Ventas Mensual por rubros " + tipoReporte.value + unidadEconomica.value}
                                    conditions={true}
                                    args={{ unidadEconomicaId: unidadEconomica.value, token: token }}
                                    hideFilter={true}
                                    paginationPageSize={20}
                                    useFlex={false}
                                />
                            </div>
                        </>
                    )
                }
                {
                    tipoReporte.value === "ventaMensualM2" &&
                    (
                        <>
                            <div className="card-body tab-content pt-0">
                                <AgTable
                                    idContent={"IndicadoresVentasMensualM2XRubros " + tipoReporte.value + unidadEconomica.value}
                                    apiService={Api.IndicadoresVentasMesM2Rubros}
                                    setAuxData={null}
                                    header={headerVentaxRubros}
                                    titleExcel={"Indicadores Ventas Mensual m2 por rubros " + tipoReporte.value + unidadEconomica.value}
                                    conditions={true}
                                    args={{ unidadEconomicaId: unidadEconomica.value, token: token }}
                                    hideFilter={true}
                                    paginationPageSize={20}
                                />
                            </div>
                        </>
                    )
                }
                {
                    tipoReporte.value === "ventaMensualCerrado" &&
                    (
                        <>
                            <div className="card-body tab-content pt-0">
                                <AgTable
                                    idContent={"IndicadoresVentasMensualCerradoXRubros " + tipoReporte.value + unidadEconomica.value}
                                    apiService={Api.IndicadoresVentasMesCerradoRubros}
                                    setAuxData={null}
                                    header={headerVentaxRubros}
                                    titleExcel={"Indicadores Ventas Mensual Cerrado por rubros " + tipoReporte.value + unidadEconomica.value}
                                    conditions={true}
                                    args={{ unidadEconomicaId: unidadEconomica.value, token: token }}
                                    hideFilter={true}
                                    paginationPageSize={20}
                                />
                            </div>
                        </>
                    )
                }
            </div>

            <Modal size="lg" show={showModal} onHide={handleCloseModal} className=''>
                <Modal.Header className='px-6 pt-6 pb-0'>
                    <Modal.Title>Lista de Contratos <div className='fw-bold mb-4 fs-5 text-gray-400'>{currentRubroContrato}</div> </Modal.Title>
                    <button type="button" onClick={handleCloseModal} className="btn btn-icon btn-sm btn-active-icon-primary">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)" fill="black"></rect>
                            <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)" fill="black"></rect>
                        </svg>
                    </button>
                </Modal.Header>
                <Modal.Body className='px-6 pt-6 pb-6'>
                    {
                        tipoReporte.value === "ventaMensual" &&
                        (
                            <>
                                <AgTable
                                    idContent={"Lista de Contratos " + tipoReporte.value + unidadEconomica.value + currentRubroContrato}
                                    apiService={Api.IndicadoresListaContratosMes}
                                    setAuxData={null}
                                    header={headerListaContratosMes}
                                    titleExcel={"Lista de Contratos " + tipoReporte.value + " " + unidadEconomica.label + " " + currentRubroContrato}
                                    conditions={true}
                                    args={{ rubroId: currentRubroId, unidadEconomicaId: unidadEconomica.value, token: token }}
                                    hideFilter={true}
                                    paginationPageSize={8}
                                    useFlex={false}
                                />
                            </>
                        )
                    }
                    {
                        tipoReporte.value === "ventaMensualM2" &&
                        (
                            <>
                                <div className="card-body tab-content pt-0">
                                    <AgTable
                                        idContent={"Lista de Contratos Mes m2" + tipoReporte.value + unidadEconomica.value + currentRubroContrato}
                                        apiService={Api.IndicadoresListaContratosMesM2}
                                        setAuxData={null}
                                        header={headerListaContratosMesM2}
                                        titleExcel={"Lista de Contratos Mes m2" + tipoReporte.value + " " + unidadEconomica.label + " " + currentRubroContrato}
                                        conditions={true}
                                        args={{ rubroId: currentRubroId, unidadEconomicaId: unidadEconomica.value, token: token }}
                                        hideFilter={true}
                                        paginationPageSize={8}
                                        useFlex={false}
                                    />
                                </div>
                            </>
                        )
                    }
                    {
                        tipoReporte.value === "ventaMensualCerrado" &&
                        (
                            <>
                                <div className="card-body tab-content pt-0">
                                    <AgTable
                                        idContent={"Lista de Contratos Mes Cerrado " + tipoReporte.value + unidadEconomica.value + currentRubroContrato}
                                        apiService={Api.IndicadoresListaContratosMesCerrado}
                                        setAuxData={null}
                                        header={headerListaContratosMesCerrado}
                                        titleExcel={"Lista de Contratos Mes Cerrado" + tipoReporte.value + " " + unidadEconomica.label + " " + currentRubroContrato}
                                        conditions={true}
                                        args={{ rubroId: currentRubroId, unidadEconomicaId: unidadEconomica.value, token: token }}
                                        hideFilter={true}
                                        paginationPageSize={8}
                                    />
                                </div>
                            </>
                        )
                    }
                </Modal.Body>
            </Modal>
        </>
    )
}

export default IndicadorVentaRubros;
